import axios from "axios";
import { environment } from "environments/environment";
import { Cookies } from "react-cookie";
const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.request.use(
    (config) => {
        const cookies = new Cookies();
        const token = cookies.get("authToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

axiosApiInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {
        const cookies = new Cookies();
        const refreshToken = cookies.get("refreshToken");
        const originalRequest = error.config;
        const formData = new FormData();
        formData.append("refresh_token", refreshToken);
        formData.append("grant_type", "refresh_token");
        if (
            refreshToken &&
      error.response.status === 401 &&
      !originalRequest._retry
        ) {
            originalRequest._retry = true;
            const res = await axios
                .post(`${environment.protocol}${environment.gatewayIp}:${environment.gatewayPort}/sts/oauth/token`, formData, {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        Authorization: `Basic ${window.btoa(`${environment.clientId}:${environment.clientSecret}`)}`,
                    },
                });
            if (res.status === 200) {
                cookies.set("authToken", res.data.access_token, {
                    path: "/",
                    maxAge: res.data.expires_in
                });
                console.log("Access token refreshed!");
                return axiosApiInstance(originalRequest);
            }
        }
        return Promise.reject(error);
    }
);

export default axiosApiInstance;
